<template>
  <SmallSquare content="暂仅支持设置当前小程序、积分商城内的链接路径，目前支持选择功能链接、商品链接、礼品链接（积分商城）。" />
  <a-tabs v-model:activeKey="activeKey">
    <a-tab-pane :key="1" tab="功能链接" v-if="webStatus">
      <toolsLink v-on:select="selectTools" />
    </a-tab-pane>
    <a-tab-pane :key="2" tab="商品链接" v-if="AppletStatus">
      <selectGood v-on:select="goodSelect" :selectList='goodList' :checkout="false" />
    </a-tab-pane>
    <a-tab-pane key="3" tab="礼品链接" v-if="AppletStatus">
      <selectGift :selectList="giftList" :checkout="false" v-on:select="giftSelect" />
    </a-tab-pane>
    <!-- <a-tab-pane key="4" tab="活动链接">
        <SmallSquare  content="开发中..."/>
   </a-tab-pane>-->
    <a-tab-pane :key="5" tab="自定义链接">
      <customize v-on:success="selectTools" />
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import toolsLink from './components/tools'
  import selectGood from '../selectGood/index'
  import customize from './components/customize'
  import { toRefs, reactive } from 'vue';
  export default {
    name: 'links',
    components: { toolsLink, selectGood, customize },
    props: {
      type: {
        type: String,
        default() { return 'normal' }
      },
      AppletStatus:{
          type:Boolean,
          default:()=>true
      },
      webStatus:{
        type:Boolean,
          default:()=>true
      }
    },
    setup(props, { emit }) {
      const state = reactive({
        goodList: [],
        giftList: [],
        activeKey: props.webStatus?1:5
      })
      const goodSelect = (data) => {
        emit('success', { url: '/pages/goods_details/index?id=' + data.id, type: state.activeKey })
      }
      const giftSelect = (data) => {
        emit('success', { url: '/pages/integralMarket/productDetail?id=' + data.id, type: state.activeKey })
      }
      const selectTools = (url) => {
        emit('success', { url: url, type: state.activeKey })
      }
      return {
        ...toRefs(state),
        goodSelect,
        giftSelect,
        selectTools,
        
      }
    }
  }
</script>